import { defineComponent as _defineComponent } from 'vue'
import LotAssignmentModal from "@/components/ui/modals/LotAssignmentModal.vue";
  import { computed } from "vue";
  import router from "@/router";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmDeleteModal',
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    deleteItem: {
      type: [Number, String],
    },
    customText: {
      type: String,
      required: false,
    },
  },
  emits: ["close", "confirm"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const emits = __emit;
  const props = __props;

  const text = computed(() => {
    if (props.customText) {
      return props.customText;
    }

    return "Are you sure you want to delete";
  });

  const isLeadsPage = computed(() => {
    return router.currentRoute.value.name === "Leads";
  });

  const close = () => {
    emits("close");
  };

  const confirm = () => {
    emits("confirm");
    emits("close");
  };

const __returned__ = { emits, props, text, isLeadsPage, close, confirm, LotAssignmentModal, computed, get router() { return router } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})